/**
 * Enum representing different VIP levels in the system.
 * The value is based in the PK of the tabel `business_levels`.
 */
export enum VipLevel {
  VIP_F_A = 2,
  VIP_F_B = 3,
  VIP_F_C = 4,
  VIP_F_D = 5,
  VIP_S_A = 7,
  VIP_S_B = 8,
  VIP_S_C = 9,
  VIP_S_D = 10,
  VIP_G_A = 12,
  VIP_G_B = 13,
  VIP_G_C = 14,
  VIP_G_D = 15,
}

/**
 * Array of Series S VIP level options
 */
export const seriesS = [
  { id: VipLevel.VIP_S_A, label: 'VIP_S_A' },
  { id: VipLevel.VIP_S_B, label: 'VIP_S_B' },
  { id: VipLevel.VIP_S_C, label: 'VIP_S_C' },
  { id: VipLevel.VIP_S_D, label: 'VIP_S_D' },
];

/**
 * Array of Series F VIP level options
 */
export const seriesF = [
  { id: VipLevel.VIP_F_A, label: 'VIP_F_A' },
  { id: VipLevel.VIP_F_B, label: 'VIP_F_B' },
  { id: VipLevel.VIP_F_C, label: 'VIP_F_C' },
  { id: VipLevel.VIP_F_D, label: 'VIP_F_D' },
];

/**
 * Array of Series G VIP level options
 */
export const seriesG = [
  { id: VipLevel.VIP_G_A, label: 'VIP_G_A' },
  { id: VipLevel.VIP_G_B, label: 'VIP_G_B' },
  { id: VipLevel.VIP_G_C, label: 'VIP_G_C' },
  { id: VipLevel.VIP_G_D, label: 'VIP_G_D' },
];

/**
 * Array of all Business level numbers
 * This is based in the attribute `business_level` in the model `BusinessLevel`
 */
export enum BusinessLevels {
  ENTRY_LEVEL = 0,
  VIP_A = 1,
  VIP_B = 2,
  VIP_C = 3,
  VIP_D = 4,
}

/**
 * Get the name of a VIP series based on letters (A-D)
 * @param {string} familyName
 * @param {number} level
 * @return {string} the name of a VIP series
 */
export function getVIPName(familyName: string, level: number): string {
  return 'VIP_' + familyName + '_' + level;
}

/**
 * Returns if the vip level id corresponds to an Entry level
 * @param {number} vipLevelId
 * @param {any} availableBusinessLevels
 * @return {boolean} a boolean indicating if the id corresponds to an Entry level
 */
export function isEntryLevel(
  vipLevelId: number,
  availableBusinessLevels: any
): boolean {
  for (const series of Object.entries(availableBusinessLevels)) {
    const seriesName = series[0];
    for (const businessLevel of availableBusinessLevels[seriesName]) {
      if (vipLevelId === businessLevel.id && businessLevel.level === 0) {
        return true;
      }
    }
  }

  return false;
}
